import i18n, { type TFunction } from 'i18next'

// using No title, as this matches the Python API behavior
export const UntitledConfigurationPlaceholder = 'No title'
export const MarketDenominationPlaceholder = 'No Market Denomination'

export function extractTitle(title: string | undefined, tFunc?: TFunction) {
  const t = tFunc ?? i18n.t
  let configurationTitle = title
  const defaultConfigurationTitle = t('configuration.title.placeholder', {
    defaultValue: 'Untitled Configuration',
    ns: 'shared',
  })
  if (!configurationTitle || configurationTitle === UntitledConfigurationPlaceholder) {
    configurationTitle = defaultConfigurationTitle
  }
  return { defaultConfigurationTitle, configurationTitle }
}
